import { type Pagination, type UserList, createUserList } from 'models';
import { useInfiniteQuery } from 'query';
import { getCommunityUsersAutocomplete } from '../services';
import type { CommunitiesUsersListFilter } from '../types';
import { getCommunityUsersInfiniteQueryKey } from './keys';

type P = {
  filter: CommunitiesUsersListFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useCommunitiesUsersInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<UserList[], string | undefined>({
    async queryFn({ pageParam: cursor }) {
      const usersResponse = await getCommunityUsersAutocomplete({
        config: {
          params: {
            community_ids: filter.communitiesIds,
            cursor,
            limit: pagination.pageSize,
            role: filter.role,
            scope: 'communities',
            search: filter.search,
          },
        },
      });

      return usersResponse.data.map((user) => createUserList(user));
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.length < pagination.pageSize ? undefined : lastPage.at(-1)?.id),
    queryKey: getCommunityUsersInfiniteQueryKey({ filter, pagination }),
    refetchOnMount: 'always',
  });
